module.exports = __webpack_public_path__ + "img/arrows.ca5a533a.svg";